export default class Awards {
  /* ===================================
   *  CONSTRUCTOR
   * =================================== */
  constructor() {
    this.autoPlayTimer = null;
    this.autoPlayDelay = 4000; // 4 seconds
    this.bindEvents();
  }

  /* ===================================
   *  EVENTS
   * =================================== */
  bindEvents() {
    if ($("#awards-list-section").length > 0) {
      this.AwardsListSetup();
    }
  }

  /* ===================================
   *  METHODS
   * =================================== */
  AwardsListSetup() {
    const $timeItems = $(".awards-time-list .time-item");
    const $detailGroups = $(".award-detail-list .detail-group-item");

    // Set initial active item to the middle of the list
    this.setInitialActiveItem($timeItems, $detailGroups);

    // Start auto-play after initial setup
    this.startAutoPlay($timeItems, $detailGroups);

    const self = this; // Store reference to 'this' for use in event handler
    $timeItems.on("click", function () {
      const selectedYear = $(this).data("year");

      // Reset auto-play timer when user clicks
      self.resetAutoPlay($timeItems, $detailGroups);

      // 1. Handle time item active state
      $timeItems.removeClass("active");
      $(this).addClass("active");

      // Handle horizontal scrolling when active item is in the latter part
      const $timeList = $(".awards-time-list");
      const timeListWidth = $timeList.width();
      const activeItemOffset = $(this).offset().left - $timeList.offset().left;

      // Only apply scrolling behavior if screen width > 900px
      if (window.innerWidth > 900) {
        // If active item is beyond 70% of visible width
        if (activeItemOffset > timeListWidth * 0.7) {
          // Scroll the list to show more items
          $timeList.animate(
            {
              scrollLeft:
                $timeList.scrollLeft() +
                (activeItemOffset - timeListWidth * 0.5),
            },
            600
          );
        }

        // If active item is within first 30% of visible width
        if (activeItemOffset < timeListWidth * 0.3) {
          // Scroll back to show earlier items
          $timeList.animate(
            {
              scrollLeft:
                $timeList.scrollLeft() -
                (timeListWidth * 0.5 - activeItemOffset),
            },
            600
          );
        }
      }

      // 2. Handle detail group active state
      $detailGroups.removeClass("active");
      const $activeDetailGroup = $detailGroups.filter(
        `[data-year="${selectedYear}"]`
      );
      $activeDetailGroup.addClass("active");

      // 3. Handle horizontal scrolling for detail group to ensure full visibility
      // Only apply scrolling behavior if screen width > 900px
      if (window.innerWidth > 900) {
        const $detailList = $(".award-detail-list");
        const detailListWidth = $detailList.width();

        // Wait for the active class to be applied and transition to complete
        setTimeout(() => {
          // Calculate the total width of all groups before the active one
          let totalWidthBeforeActive = 0;
          $detailGroups.each(function () {
            const $group = $(this);
            if ($group.data("year") < selectedYear) {
              totalWidthBeforeActive += $group.outerWidth(true);
            } else {
              return false; // Break the loop
            }
          });

          // Get the active group's dimensions
          const activeGroupWidth = $activeDetailGroup.outerWidth();

          // Calculate current scroll position
          const currentScrollLeft = $detailList.scrollLeft();

          // Calculate the visible area bounds
          const visibleLeft = currentScrollLeft;
          const visibleRight = currentScrollLeft + detailListWidth;

          // Calculate the group bounds relative to the scroll container
          const groupLeft = totalWidthBeforeActive;
          const groupRight = totalWidthBeforeActive + activeGroupWidth;

          let newScrollLeft = currentScrollLeft;

          // Check if group's left edge is outside visible area
          if (groupLeft < visibleLeft) {
            // Scroll to show the left edge of the group with some padding
            newScrollLeft = Math.max(0, groupLeft - 20);
          }
          // Check if group's right edge is outside visible area
          else if (groupRight > visibleRight) {
            // Scroll to show the right edge of the group with some padding
            const maxScrollLeft = $detailList[0].scrollWidth - detailListWidth;
            newScrollLeft = Math.min(
              maxScrollLeft,
              groupRight - detailListWidth + 20
            );
          }

          // Apply smooth scrolling if position needs to change
          if (Math.abs(newScrollLeft - currentScrollLeft) > 5) {
            // Only scroll if difference is significant
            $detailList.animate(
              {
                scrollLeft: newScrollLeft,
              },
              600
            );
          }
        }, 150); // Wait for CSS transition to complete (matches the 150ms delay in CSS)
      }
    });
  }

  /**
   * Set initial active item to the middle of the list
   * @param {jQuery} $timeItems - Time items collection
   * @param {jQuery} $detailGroups - Detail groups collection
   */
  setInitialActiveItem($timeItems, $detailGroups) {
    const totalItems = $timeItems.length;

    // If no items, return
    if (totalItems === 0) return;

    // Calculate middle index (0-based)
    // For 9 items: middleIndex = Math.floor((9-1)/2) = 4 (5th item, 0-indexed)
    const middleIndex = Math.floor((totalItems - 1) / 2);

    // Get the middle item
    const $middleItem = $timeItems.eq(middleIndex);
    const middleYear = $middleItem.data("year");

    // Set active state for time item
    $timeItems.removeClass("active");
    $middleItem.addClass("active");

    // Set active state for corresponding detail group
    $detailGroups.removeClass("active");
    const $activeDetailGroup = $detailGroups.filter(
      `[data-year="${middleYear}"]`
    );
    $activeDetailGroup.addClass("active");

    // Scroll to center the middle item in the time list (for desktop)
    if (window.innerWidth > 900) {
      const $timeList = $(".awards-time-list");
      const timeListWidth = $timeList.width();
      const middleItemOffset =
        $middleItem.offset().left - $timeList.offset().left;

      // Center the middle item
      const targetScrollLeft =
        middleItemOffset - timeListWidth / 2 + $middleItem.outerWidth() / 2;

      $timeList.scrollLeft(Math.max(0, targetScrollLeft));

      // Also scroll the detail list to show the corresponding detail group
      this.scrollToDetailGroup($activeDetailGroup, $detailGroups);
    }
  }

  /**
   * Scroll detail list to show the active detail group
   * @param {jQuery} $activeDetailGroup - The active detail group element
   * @param {jQuery} $detailGroups - All detail groups collection
   */
  scrollToDetailGroup($activeDetailGroup, $detailGroups) {
    const $detailList = $(".award-detail-list");
    const detailListWidth = $detailList.width();
    const selectedYear = $activeDetailGroup.data("year");

    // Calculate the total width of all groups before the active one
    let totalWidthBeforeActive = 0;
    $detailGroups.each(function () {
      const $group = $(this);
      if ($group.data("year") < selectedYear) {
        totalWidthBeforeActive += $group.outerWidth(true);
      } else {
        return false; // Break the loop
      }
    });

    // Get the active group's dimensions
    const activeGroupWidth = $activeDetailGroup.outerWidth();

    // Calculate current scroll position
    const currentScrollLeft = $detailList.scrollLeft();

    // Calculate the visible area bounds
    const visibleLeft = currentScrollLeft;
    const visibleRight = currentScrollLeft + detailListWidth;

    // Calculate the group bounds relative to the scroll container
    const groupLeft = totalWidthBeforeActive;
    const groupRight = totalWidthBeforeActive + activeGroupWidth;

    let newScrollLeft = currentScrollLeft;

    // Check if group's left edge is outside visible area
    if (groupLeft < visibleLeft) {
      // Scroll to show the left edge of the group with some padding
      newScrollLeft = Math.max(0, groupLeft - 20);
    }
    // Check if group's right edge is outside visible area
    else if (groupRight > visibleRight) {
      // Scroll to show the right edge of the group with some padding
      const maxScrollLeft = $detailList[0].scrollWidth - detailListWidth;
      newScrollLeft = Math.min(
        maxScrollLeft,
        groupRight - detailListWidth + 20
      );
    }

    // Apply scrolling if position needs to change
    if (Math.abs(newScrollLeft - currentScrollLeft) > 5) {
      $detailList.scrollLeft(newScrollLeft);
    }
  }

  /**
   * Start auto-play functionality
   * @param {jQuery} $timeItems - Time items collection
   * @param {jQuery} $detailGroups - Detail groups collection
   */
  startAutoPlay($timeItems, $detailGroups) {
    this.autoPlayTimer = setTimeout(() => {
      this.autoPlayNext($timeItems, $detailGroups);
    }, this.autoPlayDelay);
  }

  /**
   * Reset auto-play timer
   * @param {jQuery} $timeItems - Time items collection
   * @param {jQuery} $detailGroups - Detail groups collection
   */
  resetAutoPlay($timeItems, $detailGroups) {
    // Clear existing timer
    if (this.autoPlayTimer) {
      clearTimeout(this.autoPlayTimer);
    }

    // Start new timer
    this.startAutoPlay($timeItems, $detailGroups);
  }

  /**
   * Auto-play to next item
   * @param {jQuery} $timeItems - Time items collection
   * @param {jQuery} $detailGroups - Detail groups collection
   */
  autoPlayNext($timeItems, $detailGroups) {
    const $activeItem = $timeItems.filter(".active");
    const currentIndex = $timeItems.index($activeItem);
    const nextIndex = (currentIndex + 1) % $timeItems.length;

    // Get next item
    const $nextItem = $timeItems.eq(nextIndex);

    // Simulate click on next item
    $nextItem.trigger("click");
  }
}
